exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-yellow[data-v-1187faef]{background-color:#e8d800;color:#000;box-shadow:none!important;border:0}.btn-yellow[data-v-1187faef]:hover{background-color:#000;color:#fff}.flx[data-v-1187faef]{margin:15px 0}.reg[data-v-1187faef]{color:#000;font-size:16px}.form-signin .form-control[data-v-1187faef]{position:relative;box-sizing:border-box;height:auto;padding:10px;font-size:16px}.form-signin .form-control[data-v-1187faef]:focus{z-index:2}.form-signin input[type=email][data-v-1187faef]{margin-bottom:-1px;border-bottom-right-radius:0;border-bottom-left-radius:0}.form-signin input[type=password][data-v-1187faef]{margin-bottom:10px;border-top-left-radius:0;border-top-right-radius:0}input[data-v-1187faef]{margin:15px 0}.loginPage[data-v-1187faef]{display:flex;justify-content:center;align-items:center;height:100vh}.login[data-v-1187faef]{width:350px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1187faef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/app/pages/auth/reset.vue
// module id = 113
// module chunks = 0